import {
  bindSingleAssetAgentView, getSingleAssetBindingView, getSingleAssetMarketView,
} from "../../api/client";


async function bindAndLoad(conversationId, revision, view, idempotencyKey) {
  const binding = await bindSingleAssetAgentView(
    conversationId,
    revision,
    view,
    idempotencyKey ? { idempotencyKey } : undefined,
  );
  const bindingView = await getSingleAssetBindingView(conversationId, binding.binding_id);
  return { binding, bindingView, revision: binding.conversation_revision };
}

export async function commitRequestedRightView(result, slotIsCurrent) {
  if (!slotIsCurrent
    || result.right_view_action !== "bind_view"
    || result.right_view?.type !== "market"
    || !result.right_view?.asset_code) return null;
  return bindAndLoad(
    result.conversation_id,
    result.revision,
    result.right_view,
    `${result.timing?.turn_id || result.conversation_id}:right-view`,
  );
}

export function loadTrackedHoldingView(conversationId, revision, holding) {
  return bindAndLoad(conversationId, revision, {
    type: "holding",
    target_id: holding.holding_id,
    asset_code: holding.asset_code,
  });
}

// 「移出持仓」的收尾：后端把来源草稿恢复成可写、并把绑定指回草稿，这里只要重新读一遍
// 绑定视图，右侧就从持仓态变回草稿态（按钮跟着变成「加入持有标的」）。历史持仓查不到
// 来源草稿时后端不改绑定，这时退回该标的的行情页，免得停在一个作废的持仓上。
export async function reloadAfterUntrack(conversationId, revision, binding, restoredWorkspaceId) {
  if (restoredWorkspaceId) {
    const bindingView = await getSingleAssetBindingView(conversationId, binding.binding_id);
    return { binding: bindingView.binding, bindingView, revision };
  }
  const fallback = await bindAndLoad(conversationId, revision, {
    type: "market",
    asset_code: binding.asset_code,
  });
  return { ...fallback, marketView: await getSingleAssetMarketView(binding.asset_code) };
}
